module.exports = __webpack_public_path__ + "static/media/01PerformancePhotos.44abc6cf.jpeg";